<div class="breadcrumbs">
  <span class="title">Gestione Emergenze <mat-icon style="vertical-align: middle;">keyboard_arrow_right
    </mat-icon> Richieste DGPE </span>
</div>
<hr>
<div class="titolo flex-display">
  <span class="h1 upp">Elenco OCDPC</span>

  <button mat-stroked-button color='basic' class="pers2" (click)="onNavigate('nuova-richiesta')">
    INSERISCI OCDPC
  </button>
</div>

<mat-expansion-panel class='rett' hideToggle (opened)="arrowFlag = !arrowFlag" (closed)='arrowFlag = !arrowFlag'>
  <mat-expansion-panel-header class="colorSearch">
    <mat-panel-title class='search'>
      <mat-icon>search</mat-icon>
      <strong class="title">CERCA</strong>
      <mat-icon *ngIf="arrowFlag">keyboard_arrow_up</mat-icon>
      <mat-icon *ngIf="!arrowFlag">keyboard_arrow_down</mat-icon>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="coloredS" [formGroup]="form">

    <div class="flex-row">
      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>OCDPC</mat-label>
        <input [formControlName]="'ocdpc'" matInput>
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Informazione OCDPC</mat-label>
        <input matInput [formControlName]="'informazioniOcdpc'">
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Commissario</mat-label>
        <input matInput [formControlName]="'commissario'">
      </mat-form-field>


    </div>


    <div class="flex-row">

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Data inizio da:</mat-label>
        <input matInput [matDatepicker]="picker1" [formControlName]="'dataInizioDa'" class='searchbar'>
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Data inizio a:</mat-label>
        <input matInput [matDatepicker]="picker2" [formControlName]="'dataInizioA'" class='searchbar'>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="legacy" color='accent' class="searchbar hidden">
        <input hidden matInput>
      </mat-form-field>

    </div>

    <div class="flex-row">

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Data fine da:</mat-label>
        <input matInput [matDatepicker]="picker3" [formControlName]="'dataFineDa'" class='searchbar'>
        <mat-datepicker-toggle matSuffix [for]="picker3" ></mat-datepicker-toggle>
        <mat-datepicker #picker3></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Data fine a:</mat-label>
        <input matInput [matDatepicker]="picker4"  class='searchbar' [formControlName]="'dataFineA'">
        <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
        <mat-datepicker #picker4></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="legacy" color='accent' class="searchbar hidden">
        <input hidden matInput>
      </mat-form-field>

    </div>

  </div>
  <mat-action-row class='colored'>
    <button mat-stroked-button class="pers2" color="warn" (click)="onReset()">Reset</button>
    <button mat-raised-button class="pers2" color="accent" (click)="ricercaListaRichieste()">Cerca</button>
  </mat-action-row>
</mat-expansion-panel>


<mat-table [dataSource]="dataSource" matSort matSortActive="dataInizio" matSortDirection="desc" matSortDisableClear>

  <ng-container matColumnDef="ocdpc">
    <mat-header-cell *matHeaderCellDef mat-sort-header> OCDPC </mat-header-cell>
    <mat-cell [attr.data-label]="'OCDPC'" *matCellDef="let element">
      {{element.ocdpc}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="informazioniOcdpc">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Informazioni </mat-header-cell>
    <mat-cell [matTooltip]="element.descrizione" [matTooltipPosition]="'left'" [matTooltipClass]="'pers-tooltip'"
      [attr.data-label]="'Informazioni'" *matCellDef="let element"> {{element.informazioniOcdpc}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="territorio">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Territorio </mat-header-cell>
    <mat-cell [attr.data-label]="'Territorio'" *matCellDef="let element">
      {{element.territorio}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="commissario">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Commissario </mat-header-cell>
    <mat-cell [attr.data-label]="'Commissario'" *matCellDef="let element"> {{element.commissario}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="dataInizio">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Data inizio </mat-header-cell>
    <mat-cell [attr.data-label]="'DATA INIZIO:'" *matCellDef="let element"> {{element.dataInizio | date: 'dd/MM/yyyy'}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="dataFine">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Data fine </mat-header-cell>
    <mat-cell [attr.data-label]="'DATA FINE:'" *matCellDef="let element"> {{element.dataFine | date: 'dd/MM/yyyy'}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell [ngClass]="'customWidthClass'" *matHeaderCellDef></mat-header-cell>
    <mat-cell [ngClass]="'customWidthClass'" *matCellDef="let element">
      <span *ngIf="element.idRichiesta !== openToggle" class="material-icons tool" title="apri/chiudi toolbar"
        (click)="openToggle = element.idRichiesta">more_horiz</span>
      <myp-toolbar *ngIf="element.idRichiesta === openToggle" [toolbar]="generateToolBar(element)" role=toolbar
        [data]="element" (onToolbarEvent)="handleToolbarEvent($event)"></myp-toolbar>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

</mat-table>

<div *ngIf="this.dataSource.counter$.source['value'] === 0">
  <mat-card class="emptyTable">
    <mat-card-content>
      <h6>Non ci sono risultati</h6>
    </mat-card-content>
  </mat-card>
</div>

<mat-paginator style="flex-wrap: wrap;" id='paginator' [pageSize]="risultatiPerPagina" [pageSizeOptions]="[3, 5, 10]">
</mat-paginator>
